import * as i0 from '@angular/core';
import { Injectable, Inject, EventEmitter, ElementRef, Component, ViewEncapsulation, Input, Output, HostBinding, HostListener, NgModule } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MdlButtonComponent } from '@angular-mdl/core';

class MdlPopoverRegistry {
    // eslint-disable-next-line
    constructor(doc) {
        this.doc = doc;
        this.popoverComponents = [];
        this.doc.addEventListener("click", () => {
            this.popoverComponents
                .filter((component) => component.isVisible)
                .forEach((component) => component.hide());
        });
    }
    add(popoverComponent) {
        this.popoverComponents.push(popoverComponent);
    }
    remove(popoverComponent) {
        this.popoverComponents.slice(this.popoverComponents.indexOf(popoverComponent), 1);
    }
    hideAllExcept(popoverComponent) {
        this.popoverComponents.forEach((component) => {
            if (component !== popoverComponent) {
                component.hide();
            }
        });
    }
}
MdlPopoverRegistry.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlPopoverRegistry, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
MdlPopoverRegistry.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlPopoverRegistry, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlPopoverRegistry, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });
const BOTTOM_LEFT = "bottom-left"; // Below the element, aligned to its left.
const BOTTOM_RIGHT = "bottom-right"; // Below the element, aligned to its right.
const TOP_LEFT = "top-left"; // Above the element, aligned to its left.
const TOP_RIGHT = "top-right"; // Above the element, aligned to its right.
class PopupPositionService {
    updatePosition(forElement, popoverElement, position) {
        const coordinates = this.calculateCoordinates(forElement, popoverElement, position);
        this.applyCoordinates(coordinates, popoverElement.style);
    }
    applyCoordinates(coordinates, elementStyle) {
        if (!coordinates) {
            return;
        }
        elementStyle.right = elementStyle.bottom = "";
        elementStyle.left = coordinates.left + "px";
        elementStyle.top = coordinates.top + "px";
    }
    calculateCoordinates(forElement, popoverElement, position) {
        if (!forElement || !position) {
            return null;
        }
        switch (position) {
            case BOTTOM_RIGHT:
                return {
                    top: forElement.offsetTop + forElement.offsetHeight,
                    left: forElement.offsetLeft +
                        forElement.offsetWidth -
                        popoverElement.offsetWidth,
                };
            case BOTTOM_LEFT:
                return {
                    top: forElement.offsetTop + forElement.offsetHeight,
                    left: forElement.offsetLeft,
                };
            case TOP_LEFT:
                return {
                    top: forElement.offsetTop - popoverElement.offsetHeight,
                    left: forElement.offsetLeft,
                };
            case TOP_RIGHT:
                return {
                    top: forElement.offsetTop - popoverElement.offsetHeight,
                    left: forElement.offsetLeft +
                        forElement.offsetWidth -
                        popoverElement.offsetWidth,
                };
        }
        return null;
    }
}
PopupPositionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: PopupPositionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
PopupPositionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: PopupPositionService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: PopupPositionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }] });
class MdlPopoverComponent {
    constructor(changeDetectionRef, elementRef, popoverRegistry, popupPositionService) {
        this.changeDetectionRef = changeDetectionRef;
        this.elementRef = elementRef;
        this.popoverRegistry = popoverRegistry;
        this.popupPositionService = popupPositionService;
        // eslint-disable-next-line
        this.hideOnClick = false;
        // eslint-disable-next-line  @angular-eslint/no-output-on-prefix
        this.onShow = new EventEmitter();
        // eslint-disable-next-line  @angular-eslint/no-output-on-prefix
        this.onHide = new EventEmitter();
        this.isMdlPopover = true;
        this.isVisible = false;
        this.popoverRegistry.add(this);
    }
    onClick(event) {
        if (!this.hideOnClick) {
            event.stopPropagation();
        }
    }
    ngOnDestroy() {
        this.popoverRegistry.remove(this);
    }
    toggle(event, forElement = null) {
        if (this.isVisible) {
            this.hide();
        }
        else {
            this.show(event, forElement);
        }
    }
    hide() {
        if (this.isVisible) {
            this.onHide.emit();
            this.isVisible = false;
            this.changeDetectionRef.markForCheck();
        }
    }
    show(event, forElement = null) {
        this.hideAllPopovers();
        event.stopPropagation();
        if (!this.isVisible) {
            this.onShow.emit();
            this.isVisible = true;
            this.updateDirection(forElement);
        }
    }
    hideAllPopovers() {
        this.popoverRegistry.hideAllExcept(this);
    }
    updateDirection(forElement) {
        if (forElement && this.position) {
            const popoverElement = this.elementRef.nativeElement;
            const forHtmlElement = this.getHtmlElement(forElement);
            this.popupPositionService.updatePosition(forHtmlElement, popoverElement, this.position);
            this.changeDetectionRef.markForCheck();
            return;
        }
    }
    getHtmlElement(forElement) {
        if (forElement instanceof MdlButtonComponent) {
            return forElement.elementRef.nativeElement;
        }
        if (forElement instanceof ElementRef) {
            return forElement.nativeElement;
        }
        return forElement;
    }
}
MdlPopoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlPopoverComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: MdlPopoverRegistry }, { token: PopupPositionService }], target: i0.ɵɵFactoryTarget.Component });
MdlPopoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: MdlPopoverComponent, selector: "mdl-popover", inputs: { hideOnClick: ["hide-on-click", "hideOnClick"], position: ["mdl-popover-position", "position"] }, outputs: { onShow: "onShow", onHide: "onHide" }, host: { listeners: { "click": "onClick($event)" }, properties: { "class.mdl-popover": "this.isMdlPopover", "class.is-visible": "this.isVisible" } }, ngImport: i0, template: "<ng-content></ng-content>\n", encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlPopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: "mdl-popover", encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: MdlPopoverRegistry }, { type: PopupPositionService }]; }, propDecorators: { hideOnClick: [{
                type: Input,
                args: ["hide-on-click"]
            }], position: [{
                type: Input,
                args: ["mdl-popover-position"]
            }], 
        // eslint-disable-next-line  @angular-eslint/no-output-on-prefix
        onShow: [{
                type: Output
            }], 
        // eslint-disable-next-line  @angular-eslint/no-output-on-prefix
        onHide: [{
                type: Output
            }], isMdlPopover: [{
                type: HostBinding,
                args: ["class.mdl-popover"]
            }], isVisible: [{
                type: HostBinding,
                args: ["class.is-visible"]
            }], onClick: [{
                type: HostListener,
                args: ["click", ["$event"]]
            }] } });

class MdlPopoverModule {
    static forRoot() {
        return {
            ngModule: MdlPopoverModule,
            providers: [],
        };
    }
}
MdlPopoverModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlPopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MdlPopoverModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.0", ngImport: i0, type: MdlPopoverModule, declarations: [MdlPopoverComponent], exports: [MdlPopoverComponent] });
MdlPopoverModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlPopoverModule, providers: [MdlPopoverRegistry, PopupPositionService] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: MdlPopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    exports: [MdlPopoverComponent],
                    declarations: [MdlPopoverComponent],
                    providers: [MdlPopoverRegistry, PopupPositionService],
                }]
        }] });

/*
 * Public API Surface of popover
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MdlPopoverComponent, MdlPopoverModule, MdlPopoverRegistry, PopupPositionService };
